import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { FiChevronDown } from "react-icons/fi";
import productData from "../Datas/productData";
import { formatMoney } from "../config/storeConfig";
import "../css/shop.scss";

function Shop() {
  const [filter, setFilter] = useState("All products");
  const [sort, setSort] = useState("Featured");
  const categories = useMemo(() => ["All products", ...new Set(productData.map((item) => item.category))], []);
  const products = useMemo(() => {
    const data = filter === "All products" ? [...productData] : productData.filter((item) => item.category === filter);
    if (sort === "Price, low to high") data.sort((a, b) => Number(a.price) - Number(b.price));
    if (sort === "Price, high to low") data.sort((a, b) => Number(b.price) - Number(a.price));
    if (sort === "Alphabetically, A-Z") data.sort((a, b) => a.name.localeCompare(b.name));
    if (sort === "Alphabetically, Z-A") data.sort((a, b) => b.name.localeCompare(a.name));
    return data;
  }, [filter, sort]);
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="shop main">
      <div className="shop-header"><h1>{filter}</h1></div>
      <div className="shop-toolbar"><div className="toolbar-left">
        <label className="filter-group"><span className="label">FILTER BY</span><span className="select-wrapper"><select value={filter} onChange={(event) => setFilter(event.target.value)}>{categories.map((category) => <option key={category}>{category}</option>)}</select><FiChevronDown className="icon" aria-hidden="true" /></span></label>
        <label className="filter-group"><span className="label">SORT BY</span><span className="select-wrapper"><select value={sort} onChange={(event) => setSort(event.target.value)}>{["Featured", "Price, low to high", "Price, high to low", "Alphabetically, A-Z", "Alphabetically, Z-A"].map((option) => <option key={option}>{option}</option>)}</select><FiChevronDown className="icon" aria-hidden="true" /></span></label>
      </div><div className="toolbar-right"><span className="product-count">{products.length} products</span></div></div>
      <div className="product-grid">{products.map((item) => <Link to={`/shopDetails/${item.id}`} className="product-card" key={item.id} onClick={toTop}>
        <div className="product-image"><img src={item.images[0]} alt={item.name} /><img src={item.images[1]} alt={`${item.name}, alternate view`} className="hover-image" loading="lazy" /></div>
        <div className="product-info"><h2 className="product-name">{item.name}</h2><div className="product-price"><span>{formatMoney(item.price)}</span></div><p className="stock-note">{item.stock} in stock</p></div>
      </Link>)}</div>
    </main>
  );
}

export default Shop;

